import { useState, useContext, useEffect } from "react";
import "./Navbar.css";
import { Link } from "react-router-dom";
import { useCart } from "../../context/CartContext";
import { CurrentUserContext } from "../../context/CurrentUserContext";


function Navbar() {
  const [isNavExpanded, setIsNavExpanded] = useState<boolean>(false);
  const [isInstructor, setIsInstructor] = useState<boolean>(false);
  
  const { cartQuantity } = useCart();
  //console.log(cartQuantity);
  const {handleLogout}= useContext(CurrentUserContext)
  const user = localStorage.getItem('userName')?.toUpperCase().charAt(0);
  const role = localStorage.getItem('userRole');
  
  useEffect(() => {
    
    if (role==="Instructor") {
      setIsInstructor(true)
    } else {
      setIsInstructor(false)
    }
  },[role])
  
  return (
    
    <nav className="navigation">
      <Link to="/" className="brand-name">
      <div className="logo">
        <img src="images/logo.png" alt="logo" height="60px"></img>
      </div>
      </Link>
      <Link to="/" className="brand-name"> WE LEARN </Link>
      
      <button
        className="hamburger"
        onClick={() => {
          setIsNavExpanded(!isNavExpanded);

        }}
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          className="h-5 w-5"
          viewBox="0 0 20 20"
          fill="white"
        >
          <path
            fillRule="evenodd"
            d="M3 5a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zM3 10a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zM9 15a1 1 0 011-1h6a1 1 0 110 2h-6a1 1 0 01-1-1z"
            clipRule="evenodd"
          />
        </svg>
      </button>
      
      <div
        className={
          isNavExpanded ? "navigation-menu expanded" : "navigation-menu"
        }
      >
        {isInstructor && user && 
        <ul>
        <li onClick={() => {
            setIsNavExpanded(!isNavExpanded);
          }}>
          <Link to="/instructor"><i className="fa-solid fa-house"></i> INSTRUCTOR Home</Link>
        </li>
        <li onClick={() => {
            setIsNavExpanded(!isNavExpanded);
          }}>
          <Link to="/create-course"><i className="fa-solid fa-address-card"></i> Create Course</Link>
        </li>
        
        
        <li onClick={() => {
            setIsNavExpanded(!isNavExpanded);
          }}>
          <Link to="/courses"><i className="fa-solid fa-graduation-cap"></i> Courses</Link>
          </li>
          
        <li onClick={() => {
            setIsNavExpanded(!isNavExpanded);
          }}>
          <Link to="/login" onClick={handleLogout}><i className="fa-solid fa-arrow-right-from-bracket"></i></Link>
          </li>
          <li className="userProfile" onClick={() => {
            setIsNavExpanded(!isNavExpanded);
          }}>
          <Link to="/profile">{user}</Link>
        </li>
          
        
          </ul>
        }
        {!isInstructor && user && 

          
        
            <ul>
            <Link to={"/instructor/become-instructor"} onClick={() => {
              setIsNavExpanded(!isNavExpanded);
            }}>Become Instructor</Link>
          <li onClick={() => {
              setIsNavExpanded(!isNavExpanded);
            }}>
            <Link to="/"><i className="fa-solid fa-house"></i> Home</Link>
          </li>
          <li onClick={() => {
              setIsNavExpanded(!isNavExpanded);
            }}>
            <Link to="/about"><i className="fa-solid fa-address-card"></i> About</Link>
          </li>
          
          
          <li onClick={() => {
              setIsNavExpanded(!isNavExpanded);
            }}>
            <Link to="/courses"><i className="fa-solid fa-graduation-cap"></i> Courses</Link>
            </li>
            
          <li onClick={() => {
              setIsNavExpanded(!isNavExpanded);
            }}>
              <Link to="/cart"><i className="fa" >&#xf07a;</i>
              <span className='badge badge-warning' id='CartCount'> {cartQuantity} </span></Link>
            </li>
            
          <li onClick={() => {
              setIsNavExpanded(!isNavExpanded);
            }}>
            <Link to="/login" onClick={handleLogout}><i className="fa-solid fa-arrow-right-from-bracket"></i></Link>
            </li>
            <li className="userProfile" onClick={() => {
              setIsNavExpanded(!isNavExpanded);
            }}>
            <Link to="/profile">{user}</Link>
          </li>
            
          
            </ul>

        }
        {!user && 
          <ul>
            
          <li onClick={() => {
              setIsNavExpanded(!isNavExpanded);
            }}>
            <Link to="/"><i className="fa-solid fa-house"></i> Home</Link>
          </li>
          <li onClick={() => {
              setIsNavExpanded(!isNavExpanded);
            }}>
            <Link to="/about"><i className="fa-solid fa-address-card"></i> About</Link>
          </li>
          
          
          <li onClick={() => {
              setIsNavExpanded(!isNavExpanded);
            }}>
            <Link to="/courses"><i className="fa-solid fa-graduation-cap"></i> Courses</Link>
          </li>
          <li onClick={() => {
              setIsNavExpanded(!isNavExpanded);
            }}>
            <Link to="/cart"><i className="fa" >&#xf07a;</i>
              <span className='badge badge-warning' id='CartCount'> {cartQuantity} </span></Link>
          </li>
          <li onClick={() => {
              setIsNavExpanded(!isNavExpanded);
            }}>
            <Link to="/login"><i className="fa-solid fa-right-to-bracket"></i> Login</Link>
          </li>
          
        </ul>
        }

        
        </div> 
          </nav>  
    
  );

}
export default Navbar;